<template>
  <div>
    <div id="Daftar Nasabah">
      <div class="overflow-auto">
        <div class="row">
          <div class="col-sm-10">
            <h2>Daftar Nasabah</h2>
          </div>
        </div>

        <b-table id="funder-table" striped bordered hover responsive="sm" :items="funderItemsWithIndex" :fields="funderFields" :current-page="currentPageFunder" :per-page="perPageFunder">
          <template v-slot:cell(id)="data">
            <div class="text-center">{{ data.item.index }}</div>
          </template>
          <template v-slot:cell(setoran_awal)="data">
            <div>{{ formatCurrency(data.item.total_setoran) }}</div>
          </template>
          <template v-slot:cell(total_pengajuan)="data">
            <div class="text-center">{{ data.item.total_pengajuan }}</div>
          </template>
          <template v-slot:cell(tanggal_pengajuan_pertama)="data">
            <div class="text-center">{{ formatDate(data.item.tanggal_pengajuan_pertama) }}</div>
          </template>
          <template v-slot:cell(status_funder)="data">
            <div class="text-center" :class="data.item.status_funder ? 'text-success' : 'text-danger'">
              {{ data.item.status_funder ? 'Aktif' : 'Tidak Aktif' }}
            </div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button variant="primary" size="sm" @click="showFunderDetail(data.item)">
              Detail
            </b-button>
          </template>
        </b-table>

        <!-- Modal Detail Funder -->
        <b-modal id="detail-modal" size="lg" hide-footer v-model="showDetailModal">
          <div class="d-block">
            <h3 class="text-center mb-3 mt-0">Detail Nasabah</h3>
            <div v-if="selectedFunder">
              <!-- Flex container untuk dua kolom (kiri dan kanan) -->
              <div class="d-flex justify-content-between mb-4">
                <!-- Bagian kiri (informasi funder) -->
                <div class="w-50 pr-3">
                  <p class="rm-mb"><strong>Nama:</strong> {{ selectedFunder.funder_name }}</p>
                  <p class="rm-mb"><strong>Email:</strong> {{ selectedFunder.funder_email }}</p>
                  <p class="rm-mb"><strong>No HP:</strong> {{ selectedFunder.funder_phone }}</p>
                  <p class="rm-mb"><strong>Total Setoran:</strong> {{ formatCurrency(selectedFunder.total_setoran) }}</p>
                  <p class="rm-mb"><strong>Total Pengajuan:</strong> {{ selectedFunder.total_pengajuan }}</p>
                  <p class="rm-mb"><strong>Tanggal Pengajuan Pertama:</strong> {{ formatDate(selectedFunder.tanggal_pengajuan_pertama) }}</p>
                </div>
                <!-- Bagian kanan (button Lihat Funder) -->
                <div class="w-50 pl-3 text-right">
                  <b-button variant="primary" size="sm" @click="$router.push(`/show-funder/${selectedFunder.funder_id}`)" class="animated-button">
                    Lihat Detail Nasabah
                  </b-button>
                </div>
              </div>

              <h3 class="text-center mb-3">Detail Pengajuan</h3>
              <b-table striped bordered hover responsive="sm" :items="selectedFunder.pengajuan_funder" :fields="detailFields" small class="mb-3">
                <template v-slot:cell(setoran_awal)="data">
                  <div class="text-center">
                    {{ formatCurrency(data.item.setoran_awal) }}
                  </div>
                </template>
                <template v-slot:cell(active)="data">
                  <div class="text-center" :class="data.item.is_active ? 'text-success' : 'text-danger'">
                    {{ data.item.is_active ? 'Aktif' : 'Tidak Aktif' }}
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <b-button variant="outline-success" size="sm" @click="downloadSK(data.item.id)">
                      Download Surat Kuasa
                    </b-button>
                  </div>
                </template>

              </b-table>
            </div>
            <div v-else>
              <p class="text-center">Tidak ada data untuk ditampilkan.</p>
            </div>
          </div>
        </b-modal>

        <!-- Modal Status Berhasil -->
        <b-modal size="sm" v-model="successModal" hide-footer hide-header>
          <div class="d-block text-center">
            <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
            <h3>Status berhasil diubah</h3>
          </div>
          <div class="row">
            <div class="col">
              <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
            </div>
          </div>
        </b-modal>

        <h2 v-if="!loaded" class="text-center">
          <b-spinner variant="warning"></b-spinner>
        </h2>

        <b-pagination align="center" :per-page="perPageFunder" aria-controls="funder-table" v-model="currentPageFunder"></b-pagination>
      </div>
    </div>


  </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';

const funderFields = [
  { key: 'id', label: 'No', sortable: true },
  { key: 'funder_name', label: 'Nama', sortable: true },
  { key: 'funder_phone', label: 'No HP', sortable: false },
  { key: 'funder_email', label: 'Email', sortable: false },
  { key: 'setoran_awal', label: 'Total Setoran', sortable: true },
  { key: 'total_pengajuan', label: 'Total Pengajuan', sortable: true },
  { key: 'tanggal_pengajuan_pertama', label: 'Tanggal Pengajuan Pertama', sortable: true },
  { key: 'status_funder', label: 'Status', sortable: false },
  { key: 'aksi', label: 'Aksi', sortable: false }
];

export default {
  name: "DaftarNasabah",
  data() {
    return {
      funderItems: [],
      funderFields: funderFields,
      perPageFunder: 5,
      currentPageFunder: 1,
      loaded: false,
      successModal: false,
      selectedFunder: null,  // Menyimpan funder yang dipilih untuk detail
      showDetailModal: false,
      detailFields: [
        { key: 'id', label: 'ID' },
        { key: 'product.nama_produk', label: 'Nama Produk' },
        { key: 'product.sub_product_category.name', label: 'Kategori' },
        { key: 'setoran_awal', label: 'Setoran Awal' },
        { key: 'started_at', label: 'Tanggal Mulai' },
        { key: 'active', label: 'Status' },
        { key: 'action', label: 'Action' }, // todo: saya ingin menambahkan tombol download document surat kuasa yang diambil dari pengajuan id
      ],
    };
  },
  mounted() {
    this.loadFunders();
  },
  computed: {
    funderItemsWithIndex() {
      return this.funderItems.map((item, index) => ({
        ...item,
        index: index + 1 + (this.currentPageFunder - 1) * this.perPageFunder
      }));
    },
  },
  methods: {
    loadFunders() {
      Pengajuan.listNasabah()
        .then(res => {
          // console.log('data funder', res.data.data);
          this.funderItems = res.data.data; // Data dari API
          this.loaded = true;
        })
        .catch(err => {
          console.log(err);
          this.loaded = false;
        });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(value);
    },
    formatDate(timestamp) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(timestamp).toLocaleDateString('id-ID', options);
    },
    showFunderDetail(funder) {
      this.selectedFunder = funder;
      // console.log('data funder 1', funder);
      this.showDetailModal = true;  // Tampilkan modal detail
    },
    async downloadSK(pengajuanId) {
      this.isDownloadingSK = true;
      try {
        const getDocumentResponse = await Pengajuan.getDocumentUrl({
          pengajuan_id: pengajuanId,
          to_cdn: true
        });
        if (getDocumentResponse.data.meta.code === 200) {
          const { url: documentUrl } = getDocumentResponse.data.data;

          window.open(documentUrl, '_blank');

          this.showToast("Dokumen dibuka di tab baru.", "Sukses", "success");
        } else {
          this.showToast(getDocumentResponse.data.meta.message || "Gagal mendapatkan dokumen.", "Kesalahan", "danger");
        }
      } catch (error) {
        console.error("Terjadi kesalahan saat membuka dokumen.", error);
        this.showToast("Terjadi kesalahan saat membuka dokumen.", "Kesalahan", "danger");
      } finally {
        this.isDownloadingSK = false;
      }
    },
    showToast(message, title, variant = "default") {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
  }
};
</script>

<style scoped>
.rm-mb {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/daftar-funder.vue